import ConditionalRender from "components/atoms/conditional-render/ConditionalRender";
import Headline from "components/atoms/headline/Headline";
import Icon from "components/atoms/icon/Icon";
import Card from "components/molecules/card/Card";
import { IPendingsListCardProps } from "components/molecules/card/pendings-list-card/PendingsListCard";
import AppointmentTable from "components/organisms/pendings/appointment-table/AppointmentTable";
import CreatePending from "components/organisms/pendings/create-pendings/CreatePending";
import CustomersTable from "components/organisms/pendings/customers-table/CustomersTable";
import LeadTable from "components/organisms/pendings/lead-table/LeadTable";
import OwnTable from "components/organisms/pendings/own-table/OwnTable";
import { CardType } from "lib/helpers/constants/cardTypes";
import { IconType } from "lib/helpers/constants/iconTypes";
import { useAppointmentPendings } from "lib/hooks/queries/Pendings/useAppointmentPendings";
import { useCustomerPendings } from "lib/hooks/queries/Pendings/useCustomerPendings";
import { useHrPendings } from "lib/hooks/queries/Pendings/useHrPendings";
import { useLeadPendings } from "lib/hooks/queries/Pendings/useLeadPendings";
import { useOwnPendings } from "lib/hooks/queries/Pendings/useOwnPendings";
import { usePermissions } from "lib/hooks/shared/usePermissions";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const Pendings = () => {
  const { data: customersData, isLoading,

  } = useCustomerPendings();

  const { data: ownData, isLoading: ownLoading } = useOwnPendings();

  const { data: appointmentData, isLoading: appointmentLoading } = useAppointmentPendings();

  const { data: leadData, isLoading: leadLoading } = useLeadPendings();

  const { data: hrData, isLoading: hrLoading } = useHrPendings();


  const [isShowedPendingList, setIsShowedPendingList] = useState<boolean>(false);
  const { t } = useTranslation();

  const [isCreatePendingModalOpen, setIsCreatePendingModalOpen] = useState<boolean>(false);

  const [currentPending, setCurrentPending] = useState<number>(1); useState<boolean>(false);

  const cardsListData = [
    usePermissions(['pending_hr_view_view', 'pending_hr_view_view_own']) ? {
      id: "1",
      label: t("HR Pendings"),
      icon: IconType.HR_ICON,
      data: hrData?.data ?? [],
      isLoading: hrLoading,
      color: "#FFE39B",
      type: "hr",
      showViewAllButton: false
    } : null as any,
    usePermissions(['pending_customer_view_view', 'pending_customer_view_view_own']) ? {
      id: "2",
      label: t("Customer Pendings"),
      icon: IconType.CUSTOMERS_ICON,
      color: "#00D097",
      data: customersData?.pages?.[0]?.data?.data ?? [],
      isLoading: isLoading,
      showViewAllButton: true,
      type: "customer"
    } : null as any,
    usePermissions(['pending_myown_view_view']) ? {
      id: "3",
      label: t("My own Pendings"),
      icon: IconType.PENDINGS_ICON,
      color: "#15C0E6",
      canCreateNewPending: true,
      type: "own",
      data: ownData?.pages?.[0]?.data?.data ?? [],
      isLoading: ownLoading,
      showViewAllButton: true
    } : null as any,
    usePermissions(['pending_other_view_view', 'pending_other_view_view_own']) ? {
      id: "4",
      label: t("Other Pendings"),
      icon: IconType.PENDINGS_ICON,
      color: "#6D5DD3",
      showViewAllButton: false
    } : null as any,
    usePermissions(['pending_appointment_view', 'pending_appointment_view_view_own']) ? {
      id: "5",
      label: t("Appointment Pendings"),
      icon: IconType.APPOINTMENT_CALENDAR_ICON,
      data: appointmentData?.pages?.[0]?.data?.data ?? [],
      isLoading: appointmentLoading,
      color: "#6D5DD3",
      type: "appointment",
      showViewAllButton: true
    } : null as any,
    usePermissions(['pending_lead_view', 'pending_lead_view_view_own']) ? {
      id: "6",
      label: t("Lead Pendings"),
      icon: IconType.LEADS_ICON,
      data: leadData?.pages?.[0]?.data?.data ?? [],
      isLoading: leadLoading,
      color: "#6D5DD3",
      type: "lead",
      showViewAllButton: true
    } : null as any
  ];

  const [ViewAllData, setViewAllData] = useState<string>('customer');

  return (
    <>
      <div className="flex items-center justify-between flex-wrap sm:flex-nowrap pb-5 sm:pb-0 gap-5">
        <div className="basis-full sm:basis-auto">
          <div className="flex items-center cursor-pointer  gap-2" onClick={() => setIsShowedPendingList(false)}>
            {isShowedPendingList && (
              <div className="flex-none mt-[46px] !mb-0 sm:!mb-[33px]" >
                <Icon iconType={IconType.BACK_BUTTON_MODAL} color="var(--theme)" className="w-8 h-auto" />
              </div>
            )}

            <Headline title="Pendings" className="!mb-0 sm:!mb-[33px]" />
          </div>
        </div>
        {/* <ConditionalRender condition={!isShowedPendingList}>
          <div className="flex items-center gap-[16px] w-full sm:w-auto flex-col sm:flex-row">
            <IconButton
              icon={<Icon iconType={IconType.UPLOAD_FILE_ICON} color="white" />}
              className="w-full sm:w-auto"
            >
              {t('Upload Pending')}
            </IconButton>
            <IconButton
              onClick={() => setIsCreatePendingModalOpen(true)}
              icon={<Icon iconType={IconType.INCRASE_ICON} color="white" />}
              className="w-full sm:w-auto"

            >
              {t('New Pending')}
            </IconButton>
          </div>
        </ConditionalRender> */}
      </div>
      <ConditionalRender condition={!isShowedPendingList}>
        <div className="grid grid-cols-1 lg:grid-cols-2 items-start gap-5">
          {cardsListData.map((item) => {
            if (item === null) return null
            return (
              <Card<IPendingsListCardProps>
                key={item.id}
                {...item}
                props={{
                  label: item.label,
                  icon: item.icon,
                  color: item.color,
                  setIsShowedPendingList: setIsShowedPendingList,
                  data: item?.data,
                  type: item?.type,
                  isLoadingData: item?.isLoading,
                  setViewAllData: setViewAllData,
                  showViewAllButton: item?.showViewAllButton,
                }}
                cardType={CardType.PENDINGS_LIST_CARD}
              />
            );
          })}
        </div>
      </ConditionalRender>
      <ConditionalRender condition={isShowedPendingList}>
        {
          {
            'customer': <CustomersTable  />,
            'lead': <LeadTable />,
            'appointment': <AppointmentTable />,
            'own': <OwnTable />,
          }[ViewAllData]
        }
      </ConditionalRender>
      <ConditionalRender condition={currentPending === 1}>
        <CreatePending
          currentPending={currentPending}
          hocClasses={{
            modalClassName:
              currentPending === 1 ? "w-[500px] md:w-[500px] lg:w-[551px]" : ""
          }}
          hocCurrentStep={currentPending}
          hocToggleModal={() =>
            setIsCreatePendingModalOpen(!isCreatePendingModalOpen)
          }
          hocisOpen={isCreatePendingModalOpen}
          setHocCurrentStep={setCurrentPending}
          clearData={true}
          hocTitle="Create New Pending"
        />
      </ConditionalRender>
    </>
  );
};

export default Pendings;
